import { z } from 'zod';
export const ETAPES_INVESTISSEMENT = {
  DRAFT: 'Brouillon',
  SUBMITTED: 'Transmis',
  CANCELLED: 'Annulé',
} as const;
export const schemaInvestissementReseau = z
  .object({
    titre: z.string().trim().min(5).max(200),
    justification: z.string().trim().min(20).max(8000),
    montant: z.number().int().min(0).max(100000000000),
    equipement_id: z.string().uuid().nullable().default(null),
  })
  .strict();
export const schemaActionInvestissementReseau = schemaInvestissementReseau
  .partial()
  .extend({
    equipement_id: z.string().uuid().nullable().optional(),
    action: z.enum(['reviser', 'transmettre', 'annuler']),
    version: z.number().int().positive(),
    motif: z.string().trim().min(5).max(2000),
  })
  .strict()
  .superRefine((d, c) => {
    const champs = ['titre', 'justification', 'montant', 'equipement_id'] as const;
    if (
      d.action === 'reviser'
        ? champs.some((k) => d[k] === undefined)
        : champs.some((k) => d[k] !== undefined)
    )
      c.addIssue({
        code: 'custom',
        message: 'Les quatre champs de la demande sont requis uniquement pour une révision',
      });
  });
